module.exports = __webpack_public_path__ + "media/components/country-flag/static/jm-8429d00bcea6355c54631f57a6179fd6.svg";